// @flow

import { alertShow } from "./alert";
import { communicationsError } from "./communications";
import { postJSON } from "../fetch-json";
import { wrapWithAlertError, wrapWithAlertSuccess, wrapWithComms } from "./async";

import type { Dispatch } from "redux";

export const UPDATE_AVATAR_TIMESTAMP = "UPDATE_AVATAR_TIMESTAMP";

export function updateAvatarTimestamp(userId: number) {
  return {
    type: UPDATE_AVATAR_TIMESTAMP,
    userId,
    timestamp: new Date().getTime()
  };
}

export function passwordReset(emailAddress: string) {
  return (dispatch: Dispatch) => {
    var promise = postJSON("/api/v1/users/password-reset", {
      email: emailAddress,
      "white_label_site": window.env.whiteLabelSite
    });
    promise = wrapWithComms(promise, dispatch, "password-reset");
    promise = wrapWithAlertSuccess(promise, dispatch, "Password Reset Request Received", "If your email address exists in our system, we have sent you an email with a link to reset your password.");
    promise = wrapWithAlertError(promise, dispatch, () => "An error is preventing the form from being submitted.");
    return promise;
  };
}

export function passwordResetConfirmation(emailAddress: string, newPassword: string, verifyPassword: string, token: string) {
  return (dispatch: Dispatch) => {
    if (newPassword !== verifyPassword) {
      dispatch(alertShow("notification--error", "dw-blocked", "Error", "An error is preventing the form from being submitted."));
      dispatch(communicationsError("password-reset-confirmation", { "verify_password": ["must match New Password."] }));
      return Promise.resolve();
    } else {
      var promise = postJSON("/api/v1/users/password-reset-confirmation", {
        email: emailAddress,
        password: newPassword,
        token,
        "white_label_site": window.env.whiteLabelSite
      });
      promise = wrapWithComms(promise, dispatch, "password-reset-confirmation");
      promise = wrapWithAlertSuccess(promise, dispatch, "Your password was updated. Please log in.");
      promise = wrapWithAlertError(promise, dispatch, () => "An error is preventing the form from being submitted.");
      return promise;
    }
  };
}
